(function(){
    angular
        .module('appback')
        .directive('ngPublicaciones', publicacionesDir);

        publicacionesDir.$inject = ['socket','GenerallabService','FotopublicacionService','$timeout','Upload'];
        function publicacionesDir(socket,GenerallabService,FotopublicacionService,$timeout,Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=publicaciones.twig',
		          scope: {
		          	categorias : '=',
		          	newcard:'='
                  //ngModel : '=',
                  //item: '=',
                  //peticionid: '=',
                  //resultados: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
	                    scope.generalLab = GenerallabService;
		            	scope.options = {
				             zoomEnable          : false,
				             defaultIndex        : 0, // Order of the default selected Image
				             /* You should give images in array with object properties
				              [{
				              thumb : 'assets/images/1-thumb.jpg',
				              medium: 'assets/images/1-medium.jpg',
				              large : 'assets/images/1-large.jpg'
				              }] */
				             images              : [],
				             style               : 'inner', // inner or box
				             boxPos              : 'right-top', // e.g., right-top, right-middle, right-bottom, top-center, top-left, top-right ...
				             boxW                : 400, // Box width
				             boxH                : 400, // Box height
				             method              : 'lens', // fallow 'lens' or 'pointer'
				             cursor              : 'crosshair', // 'none', 'default', 'crosshair', 'pointer', 'move'
				             lens                : true, // Lens toggle
				             zoomLevel           : 2, // 0: not scales, uses the original large image size, use 1 and above to adjust.
				             immersiveMode       : '769', // false or 0 for disable, always, max width(px) for trigger
				             immersiveModeOptions: {}, // can extend immersed mode options
				             immersiveModeMessage: 'Click to Zoom', // Immersive mode message
				             prevThumbButton     : '&#9665;', // Prev thumb button (html)
				             nextThumbButton     : '&#9655;', // Next thumb button (html)
				             thumbsPos           : 'bottom', // Thumbs position: 'top', 'bottom'
				             thumbCol            : 3, // Thumb column count
				             thumbColPadding     : 4 // Padding between thumbs
				         };
		            	scope.options.zoomEnable = false;
		            	console.log("newcard",scope.newcard);

	                    //scope.newcard = {};
	                    //scope.categorias = vm.categorias;
	                    scope.selector = {};
	                    scope.label = "";
	                    scope.fotoSeleccionada = false;
	                    scope.uploadFiles = function (files) { 
	                        //console.log("item",item);
	                        if (files && files.length) {
	                          for (var i = 0; i < files.length; i++) {
	                            Upload.upload({
	                                  url: '/backend/fotopublicacion/subirficheros',
	                                  data: { file: files[i] }
	                              }).then(function (resp) {
	                                  //console.log(resp);
	                                  if(typeof(scope.newcard.filepath) == 'undefined'){
	                                      scope.newcard.filepath = [];
	                                  }
	                                  resp.data.drawer = [];
	                                  scope.newcard.filepath.push(resp.data);

	                              }, function (resp) {
	                                  //console.log('Error status: ' + resp.status);
	                              }, function (evt) {
	                                  var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	                                  //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
	                              });
	                          }
	                          //files = null;

	                        }
	                    }

	                    /*if(typeof(item)!='undefined'){
	                        scope.newcard = item;
	                    }*/

	                    scope.addFotoSeleccionada = function(files){
	                        scope.open = true;
	                        scope.fotoSeleccionada = files;
	                        scope.fotoSeleccionada.url = '/backend/uploads/fotopublicacion/'+files.file_name;
	                    }
	                    scope.close = function(){
	                        scope.open = false;
	                    }
	                    scope.buscarEspecie = function(){
	                      console.log("blur");
	                      FotopublicacionService.buscarEspecie(scope.newcard.lims_id,function(data){
	                         if(data.animal){
	                            scope.newcard.especie_id = data.animal.especie_id;
	                         }
	                      });
	                    }

	                    scope.drawer = [
	                        
	                    ];

	                    scope.addRect = function (selector,label) {
	                        console.log("fotoSeleccionada",scope.fotoSeleccionada);
	                        if(angular.isUndefined(scope.fotoSeleccionada.drawer)){
	                          scope.fotoSeleccionada.drawer = [];
	                        }
	                        scope.fotoSeleccionada.drawer.push({
	                            x1: scope.selector.x1,
	                            y1: scope.selector.y1,
	                            x2: scope.selector.x2,
	                            y2: scope.selector.y2,
	                            color: '#a94442',
	                            stroke: 3,
	                            title:label,
	                            label:label
	                        });
	                        scope.label = "";
	                        label = "";
	                        console.log("fotoSeleccionadanew",scope.fotoSeleccionada);
	                        //scope.fotoSeleccionada.drawer = scope.drawer; 
	                        selector.clear();
	                    };
			        });



					
		        }
          }
      }
})();